export const formatTime = (dateStr: string): string => {
  const date = new Date(dateStr);
  const hh = date.getUTCHours().toString().padStart(2, "0");
  const mm = date.getUTCMinutes().toString().padStart(2, "0");
  return `${hh}:${mm}`;
};


export const formatDate = (dateStr: string): string => {
  const date = new Date(dateStr);
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");
  return `${month}/${day}`;
};


export const formatDateTime = (dateStr: string): string => {
  const date = new Date(dateStr);
  const month = (date.getUTCMonth() + 1).toString().padStart(2, "0");
  const day = date.getUTCDate().toString().padStart(2, "0");
  const hh = date.getUTCHours().toString().padStart(2, "0");
  const mm = date.getUTCMinutes().toString().padStart(2, "0");
  return `${month}/${day} ${hh}:${mm}`;
};
